import { render, staticRenderFns } from "./TeacherInformation.vue?vue&type=template&id=ed113614&scoped=true"
import script from "./TeacherInformation.vue?vue&type=script&lang=js"
export * from "./TeacherInformation.vue?vue&type=script&lang=js"
import style0 from "./TeacherInformation.vue?vue&type=style&index=0&id=ed113614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed113614",
  null
  
)

export default component.exports